// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Arrow_wrapper__EYrJk","img":"Arrow_img__3_H3V","left":"Arrow_left__cK0Re","right":"Arrow_right__WEje8","show":"Arrow_show__cwhTa","hide":"Arrow_hide__2eWSt"};